import * as React from "react";
const SvgMinimize220Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 9h7V7h-3.586l3.793-3.793-1.414-1.414L13 5.586V2h-2v7Zm-5.414 4-3.793 3.793 1.414 1.414L7 14.414V18h2v-7H2v2h3.586Z",
      clipRule: "evenodd"
    })
  );
export default SvgMinimize220Px;
